<template>
  <GoogleMaps :preload="preload" @reachViewport="initMapService" class="hotel-map">
    <div class="hotel-map__wrapper" ref="mapWrapper" />
  </GoogleMaps>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import HotelMapMixin from '@/components/googleMap/HotelMapMixin'
import GoogleMaps from '@/components/GoogleMaps'
import GoogleMapsMixin from '@/components/GoogleMapsMixin'
import { API } from '@/modules/api'
import { mapMarkerIcon } from '@/modules/globals'
import GoogleMapsService from '@/services/GoogleMapsService'

@Component({
  mixins: [
    GoogleMapsMixin,
    HotelMapMixin,
  ],
  components: {
    GoogleMaps,
  },
  props: {
    config: {
      type: Object,
      required: false,
    },
    preload: {
      type: Object,
      required: false,
    },
  },
})
export default class HotelMap extends Vue {
  mounted () {
    if (!this.preload) this.initMapService()
  }

  initMapService () {
    new GoogleMapsService().init()
      .then(() => new API().getJsonForHotelMap())
      .then(json => this.setMapData(json))
      .then(() => this.setMapRootElements())
      .then(() => this.init())
  }

  setMapRootElements () {
    this.mapWrapper = this.$refs.mapWrapper
  }

  get hotelLatitude () {
    const attr = this.config.latitude
    return attr.length ? attr : this.defaultLatitude
  }

  get hotelLongitude () {
    const attr = this.config.longitude
    return attr.length ? attr : this.defaultLongitude
  }

  mapSettings () {   
    return {
      zoom: parseInt(this.mapData.zoom),
      center: this.getCenterCoords({
        latitude: this.hotelLatitude,
        longitude: this.hotelLongitude,
      }),
      styles: this.loadCustomMapStyles(this.mapData.styles),
      mapTypeControl: false,
      streetViewControl: false,
      zoomControlOptions: {
        position: window.google.maps.ControlPosition.TOP_LEFT,
      },
    }
  }

  init () {
    this.defaultLatitude = this.mapData.latitude
    this.defaultLongitude = this.mapData.longitude
    this.googleMap = this.setNewMap(this.mapWrapper, this.mapSettings())

    const position = this.setNewMarkerPosition(this.hotelLatitude, this.hotelLongitude)    
    this.getMarker(position, this.googleMap, mapMarkerIcon.franczyza)
  }
}
</script>

<style lang="scss">
.hotel-map__wrapper {
  height: 375px;
  width: 100%;
  z-index: 1;

  @media screen and (min-width: 1350px) {
    height: 525px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/googleMap/HotelMap.vue